import React, { useState, useEffect } from 'react';
import './TauriBreadcrumbs.css';
import config from '../../config.json';
import TauriBreadcrumbHeadingTitle from './TauriBreadcrumbHeadingTitle/TauriBreadcrumbHeadingTitle';
import TauriIdentifierDropdown from './TauriBreadcrumbDropdown/TauriIdentifierDropdown/TauriIdentifierDropdown';
import TauriConfigTypeCodeDropdown from './TauriBreadcrumbDropdown/TauriConfigTypeCodeDropdown/TauriConfigTypeCodeDropdown';
import TauriMonthAndYearDropdown from './TauriBreadcrumbDropdown/TauriMonthAndYearDropdown/TauriMonthAndYearDropdown';
import TauriImage from '../TauriImage/TauriImage';
import TauriExportDialog from '../TauriExportDialog/TauriExportDialog';
import { useFilterContext } from '../TauriGlobalContext/TauriGlobalContext';

const TauriBreadcrumbs = ({ parent, name, separator }) => {
    const [paths, setPaths] = useState([]);

    const getUserData = localStorage.getItem('UserData');
    const decodedUserData = JSON.parse(atob(getUserData));

    const permission = localStorage.getItem('permission');
    const decodedPermission = JSON.parse(atob(permission));
    localStorage.setItem('ConfigTypeCode', config.ConfigTypeCode);
    localStorage.setItem('EmployeeCode', decodedPermission?.DataScope?.AccessRange);

    const { updateFilterValue } = useFilterContext();

    const loadBreadcrumbs = (parent, name) => {
        const matchingRoutes = findMatchingRoutes(parent, name);
        const extractedRoutes = extractRoutes(matchingRoutes);
        if (extractedRoutes[0]) {
            if (extractedRoutes[0].length == 1) {
                setPaths(extractedRoutes[0]);
            } else {
                const remainingRoutes = extractedRoutes[0].slice(1);
                setPaths(remainingRoutes);
            }
        }
    }

    useEffect(() => {
        if (parent.id) {
            loadBreadcrumbs(parent, name)
        }
    }, [parent, name])

    const findMatchingRoutes = (json, name) => {
        const matchingRoutes = [];

        const traverse = (node, currentPath, route) => {
            if (node.name === currentPath) {
                matchingRoutes.push(route);
            }

            if (node.children) {
                for (const child of node.children) {
                    traverse(child, currentPath, [...route, child]);
                }
            }
        };

        traverse(json, name, [json]);
        return matchingRoutes;
    };

    const extractRoutes = (matchingRoutes) => {
        const extractedRoutes = [];
        for (const route of matchingRoutes) {
            const extractedRoute = [];
            for (const node of route) {
                extractedRoute.push({
                    id: node.id,
                    name: node.name,
                    icon: node.icon,
                    path: node.path,
                    roleLevel: node.roleLevel
                });
            }
            extractedRoutes.push(extractedRoute);
        }
        return extractedRoutes;
    };

    const handleOnclick = (clickName) => {
        if (parent.id) {
            loadBreadcrumbs(parent, clickName);
        }
    }

    const [showExport, setShowExport] = useState(false);
    const [selectedDates, setSelectedDates] = useState(() => ({
        FromMonth: null,
        FromYear: null,
        ToMonth: null,
        ToYear: null,
    }));

    const [codenameKey, setCodenameKey] = useState('');
    const [selectedCode, setSelectedCode] = useState('');
    const [selectedConfigTypeCode, setSelectedConfigTypeCode] = useState(config.ConfigTypeCode.split(',')[0]?.toString());

    useEffect(() => {
        const newFilter = {
            FromMonth: selectedDates.FromMonth?.toString(),
            FromYear: selectedDates.FromYear?.toString(),
            ToMonth: selectedDates.ToMonth?.toString(),
            ToYear: selectedDates.ToYear?.toString(),
            [codenameKey]: selectedCode,
            ConfigTypeCode: selectedConfigTypeCode?.toString(),
            EmployeeCode: decodedPermission?.DataScope?.AccessRange?.toString(),
        };

        updateFilterValue(newFilter);
        localStorage.setItem("filterData", JSON.stringify(newFilter));

    }, [selectedDates, selectedConfigTypeCode, selectedCode]);

    const handleExportClick = () => {
        setShowExport(true);
    };

    const handleHideExport = () => {
        setShowExport(false);
    };

    const handleSelectedIdentifier = (key, value) => {
        setSelectedCode(value);
        setCodenameKey(key);
    };

    const handleDateChange = (dateValue) => {
        setSelectedDates(dateValue);
    };

    const handleConfigTypeCodeChange = (configtype) => {
        localStorage.setItem('selectedConfig', configtype);
        setSelectedConfigTypeCode(configtype)
    };

    return (
        <div className="breadcrumbs-container d-flex flex-column flex-xl-row justify-content-between align-items-start py-2 px-2 px-xl-4">
            <div className="left-component d-flex align-items-center">
                <TauriBreadcrumbHeadingTitle paths={paths} handleOnclick={handleOnclick} separator={separator} />
            </div>
            <div className="right-component">
                <div className="tauri-filter d-flex align-items-center">
                    <TauriMonthAndYearDropdown onDateChange={handleDateChange} />
                    {(decodedUserData?.CodeList?.length > 0) &&
                        <TauriIdentifierDropdown AccessRange={decodedPermission?.DataScope?.AccessRange} AccessCodes={decodedUserData?.CodeList || []} AccessLevel={decodedPermission?.DataScope?.Access} handleSelected={handleSelectedIdentifier} />
                    }

                    {(config.ConfigTypeCode.split(',').length > 1) &&
                        <TauriConfigTypeCodeDropdown
                            ConfigCode={config.ConfigTypeCode}
                            handleSelected={handleConfigTypeCodeChange}
                        />
                    }

                    <TauriImage
                        localImage="/Images/download.svg"
                        alt="Download"
                        className="d-none"
                        onClick={handleExportClick}
                    />
                    <TauriImage localImage="/Images/email.svg" alt="Email" className="d-none" />
                    <TauriImage localImage="/Images/share.svg" alt="Share" className="d-none" />

                    {showExport &&
                        <TauriExportDialog show={showExport} onHide={handleHideExport} />
                    }
                </div>
            </div>
        </div>
    );
};

export default TauriBreadcrumbs;